export const imageHardSize = wrapper => {
	wrapper.find('.image-block__item').each(function() {
		let h = $(this).height();

		if (h == 0) {
			let papa = $(this).parent();
			do {
				h = papa.height();
				papa = papa.parent();
			} while (h == 0);

			let w = $(this).width();

			$(this).children('img').css({
				'min-width': w,
				'min-height': h
			});
		}
	});
}